import Vue from 'vue';
import { orderBy } from 'lodash-es';

export default {
  namespaced: true,
  state: {
    loadingStatus: 'init',
    all: {},
  },
  getters: {
    allSortedByStartingTime: (state) => orderBy(
      Object.values(state.all),
      ['startingTime.seconds', 'name'],
      ['asc'],
    ),
  },
  mutations: {
    RESET_STATE(state) {
      state.loadingStatus = 'init';
      state.all = {};
    },
    SET_LOADING_STATUS(state, loadingStatus) {
      state.loadingStatus = loadingStatus;
    },
    SET_EVENT(state, { id, ...data }) {
      const eventData = { ...data };

      // Read-only id property
      Object.defineProperty(eventData, 'id', {
        value: id,
        enumerable: true,
      });
      Vue.set(state.all, id, eventData);
    },
    REMOVE_EVENT(state, id) {
      Vue.delete(state.all, id);
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    async onEventsSnapshot({ commit }, snapshot) {
      // Set loading status
      commit('SET_LOADING_STATUS', 'snapshot-loading');

      snapshot.docChanges().forEach((snapshotChange) => {
        if (snapshotChange.type === 'added' || snapshotChange.type === 'modified') {
          commit('SET_EVENT', {
            id: snapshotChange.doc.id,
            ...snapshotChange.doc.data(),
          });
        } else if (snapshotChange.type === 'removed') {
          commit('REMOVE_EVENT', snapshotChange.doc.id);
        }
      });

      commit('SET_LOADING_STATUS', 'snapshot-loaded');
    },
    async onEventSnapshot({ state, commit }, snapshot) {
      commit('SET_LOADING_STATUS', 'snapshot-loading');

      commit('SET_EVENT', {
        id: snapshot.id,
        ...snapshot.data(),
      });

      if (state.loadingStatus === 'snapshot-loading') commit('SET_LOADING_STATUS', 'snapshot-loaded');
    },
  },
};
